import ImgSeeMore from "assets/images/see_more.png";
import ImgNext from "assets/images/next_img.png";
import ImgPrev from "assets/images/prev_img.png";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import * as S from "./style";
import { listNewsApi } from "apis";
import moment from "moment-timezone";
import { CategoryNewsApi } from "apis/home";
import { useTranslation } from "react-i18next";

// const dataDefaultYear = ["2022", "2021", "2020", "2019", "2018"];

function News() {
  const [dataYear, setDataYear] = useState("");
  const [dataAllYear, setDataAllYear] = useState([""]);
  const [dataNews, setDataNews] = useState<any[]>([]);
  const customSlider: any = useRef(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const SIZE = 4;
  const CURRENT_PAGE = 1;
  const { t } = useTranslation("common");

  const getDataApi = async (params?: any) => {
    const { data }: any = await listNewsApi({
      page: page,
      size: SIZE,
      year: Number(dataYear),
      ...params,
    });
    if (data) {
      setTotalPage(data?.pageable?.totalPage);
      if (data?.pageable?.page > 1) setDataNews([...dataNews, ...data.datas]);
      else setDataNews(data?.datas);
    } else {
      setDataNews([]);
    }
  };

  useEffect(() => {
    (async function getCategoryNew() {
      try {
        const { data }: any = await CategoryNewsApi();
        if (data) {
          const dataReverse = data.reverse();
          setDataYear(dataReverse[0]);
          setDataAllYear(dataReverse);
          getDataApi({ year: dataReverse[0] });
        }
      } catch (error) {}
    })();
  }, []);

  // useEffect(() => {
  //   if (dataYear) getDataApi();
  // }, []);

  const settings = {
    className: "center",
    infinite: false,
    slidesToShow: 5,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const gotoNext = () => {
    customSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customSlider.current.slickPrev();
  };

  const handleClickYear = (data: string) => {
    setDataYear(data);
    setPage(CURRENT_PAGE);
    getDataApi({
      page: CURRENT_PAGE,
      year: Number(data),
    });
  };

  return (
    <S.Container id="news">
      <div className="container">
        <div className="title-main">| NEWS</div>
        <div className="wp-slider">
          <button className="btn-prev" onClick={() => gotoPrev()}>
            <img src={ImgPrev} alt="img prev" />
          </button>
          <button className="btn-next" onClick={() => gotoNext()}>
            <img src={ImgNext} alt="img next" />
          </button>
          <Slider {...settings} ref={customSlider}>
            {dataAllYear.map((data, index) => (
              <div
                className={`item-slider ${
                  dataYear === data ? "item-slider__active" : ""
                }`}
                key={index}
                onClick={() => handleClickYear(data)}
              >
                {data}
              </div>
            ))}
          </Slider>
        </div>

        <div className="box-content">
          {dataNews?.map((data: any, index) => (
            <a
              className="box"
              key={index}
              target="_blank"
              href={data?.urlArticle}
            >
              <div className="box-title">
                <div className="title">{data?.pressName}</div>
                <div className="date">
                  {moment(data?.publishTime).format("YYYY.MM.DD")}
                </div>
              </div>
              <div className="content">{data?.title}</div>
            </a>
          ))}
        </div>

        {page < totalPage && (
          <div
            className="see-more"
            onClick={() => {
              // if (page < totalPage) {
              setPage((prev) => prev + 1);
              getDataApi({
                page: page + 1,
              });
              // }
            }}
          >
            <div className="text">{t("MORE")}</div>
            <img src={ImgSeeMore} alt="see more img" />
          </div>
        )}
      </div>
    </S.Container>
  );
}

export default News;
